import { combineReducers } from 'redux';

import report from './letters/reducer';

export default combineReducers({
  report,
});



// WEBPACK FOOTER //
// ./src/pages/mbenotification/state/reducer.js